export const formattedTags = tags => {
	let changedTags = [];
	//  new
	//  tags.map((item, i) => {
	//   item.child_tags.map((item1,j)=>{
	//      let data = {}
	//      data.label = item1.display_name
	//     data.value = item1.id
	//   data.parent = item1?.parent?.display_name

	//      changedTags.push(data)
	//   })

	//  })

	// /* OLD Tags
	tags.map((item, i) => {
		let data = {};
		data.label = item.display_name;
		data.value = item.id;

		changedTags.push(data);
	});
	//
	return changedTags;
};

export const formattedTitles = titles => {
	const processedDoc = [];

	titles.forEach(item => {
		let data = {};
		data.label = item.name;
		data.value = item.id;
		data.options = item.child_titles.map(item => ({
			label: item.name,
			value: item.slug,
			id: item.id,
		}));
		processedDoc.push(data);
	});
	return processedDoc;
};

export const formattedOldTags = tags => {
	let changedTags = [];
	//  new
	tags.map((item, i) => {
		item.child_tags.map((item1, j) => {
			let data = {};
			data.label = item1.display_name;
			data.value = item1.id;
			data.parent = item1?.parent?.display_name;

			changedTags.push(data);
		});
	});

	return changedTags;
};

export const priorityColor = type => {
	switch (type) {
		case 'high':
			return '#d32f2f';
		case 'medium':
			return '#ff9800';
		case 'standard':
			return '#42a5f5';
		default:
			return 'black';
	}
};

export function capitalizeFirstLetter(str) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}
